import { Box, Card, CardContent, Checkbox, Typography } from '@mui/material'
import React, { ReactNode } from 'react'

export type ConfirmationRow = {
  key: string
  content: ReactNode
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  dataTestId: string
}

type ConfirmationCardProps = {
  confirmations: readonly ConfirmationRow[]
}

function ConfirmationCard({ confirmations }: ConfirmationCardProps) {
  if (confirmations.length === 0) return null

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Card
        elevation={0}
        sx={{
          width: '100%',
          borderRadius: '16px',
          bgcolor: '#FDFDFD',
          boxShadow: 'none',
          border: '0.5px solid rgba(0, 0, 0, 0.16)',
        }}
      >
        <CardContent sx={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {confirmations.map(({ key, content, checked, onChange, dataTestId }) => (
            <Box key={key} sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <Checkbox
                checked={checked}
                onChange={onChange}
                data-testid={dataTestId}
                sx={{
                  padding: '0',
                  marginRight: '16px',
                  marginTop: '2px',
                  alignSelf: 'flex-start',
                }}
              />
              <Typography sx={{ textAlign: 'left', fontSize: '13px', color: '#3D3D3D' }}>
                {content}
              </Typography>
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  )
}

export default ConfirmationCard
